/**
 * Build-time environment loaded by Vite from `VITE_*` variables.
 *
 * `import.meta.env` is replaced at build time; missing vars become
 * `undefined`. We validate at module load time so a misconfigured
 * production build crashes loudly on first import instead of failing
 * silently in a later network call.
 *
 * Dev: if the var isn't set, we fall back to a localhost default so
 *   `vite dev` works without forcing every contributor to copy
 *   .env.example → .env first. The default matches what
 *   docker-compose.yml uses for local dev.
 * Prod: missing var throws — `--build-arg` in apps/client/Dockerfile
 *   (or the build environment) MUST provide it.
 */

const DEV_DEFAULTS = {
  VITE_WS_URL: 'ws://localhost:3000/ws',
  VITE_API_URL: 'http://localhost:3000/api',
} as const

function readEnv(name: keyof typeof DEV_DEFAULTS): string {
  const value = import.meta.env[name]
  if (typeof value === 'string' && value.length > 0) return value
  if (import.meta.env.DEV) return DEV_DEFAULTS[name]
  throw new Error(
    `Missing required env var ${String(name)}. Set it via your build environment or .env.`,
  )
}

export const env = {
  WS_URL: readEnv('VITE_WS_URL'),
  API_URL: readEnv('VITE_API_URL'),
} as const
